<a routerLink="{{ room.url }}" queryParamsHandling="preserve">
  <div class="room-rectangle">
    <div class="container g-0">
      <div class="row g-0">
        <div class="col col-md-4">
          <img [src]="room.smallImages!.length > 0 ? room.smallImages![0].filePath! : '/images/conference-room/room-box/room-default.jpg'" [alt]="room.name" class="img-responsive"/>
        </div>

        <div class="col col-md-8">
          <div class="title">{{ room.name }}</div>
          <div class="subtitle">{{ room.maxSeats }} <i class="bi bi-person-fill"></i> • {{ room.hourlyRate! / 100 | money: room.currency!:2:false }}/hr</div>
        </div>
      </div>
    </div>
  </div>
</a>
